import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'

import HelpPane from 'components/Common/HelpPane'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function BedbankSoldOutModal() {
  const intl = useIntl()
  const { resolve } = useModalElementContext<void>()
  const modalClose = () => resolve()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'VcT3Y64MTL8Y7q0_ckJ2',
        defaultMessage: 'This room option is no longer available',
      })}
      primaryActionText={intl.formatMessage({
        id: '7vW1jE9j42pC9dCnTTa8',
        defaultMessage: 'Select a different room option',
      })}
      onPrimaryActionClick={modalClose}
    >
      <BodyText variant="large" weight="normal">
        {intl.formatMessage({
          id: '5Aaq4KMYOK1ttVyziNm7',
          defaultMessage: 'Unfortunately your selected room option sold out before we could secure them. Luckily there are alternative options for you to choose from, but make sure to act fast!',
        })}
      </BodyText>
      <HelpPane />
    </Modal>
  )
}

export default BedbankSoldOutModal
